import React, {useEffect, useState} from 'react';
import Select, { components } from 'react-select';
import apiService from '../../Services/apiServices';
import helper from '../../Services/helper';
import { MDBInput  } from "mdb-react-ui-kit";
import mdlItem from '../../Models/Item'
import { useToasts } from 'react-toast-notifications';

const ItemDetails = (props) => {
    const { addToast } = useToasts();
    const itemModel = new mdlItem()
    const [item, setItem] = useState(itemModel)
    const [errors, setErrors] = useState(itemModel)
    const [itemId, setItemId] = useState(props.props?.match?.params?.id ? props.props.match.params.id: 0)
    const [showWeights, setShowWeights] = useState(itemId > 0 ? true : false)

    let customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? "#bac8f3 !important" : "#d1d3e2",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgb(78 115 223 / 25%)" : "",
        }),
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '28.59px',
            height: '28.59px',
            boxShadow: state.isFocused ? null : null,
          }),
      
          valueContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
            padding: '0 6px'
          }),
      
          input: (provided, state) => ({
            ...provided,
            margin: '0px',
          }),
          indicatorSeparator: state => ({
            display: 'none',
          }),
          indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
          }),
    };

    const getItem = (queryName, paramName, paramValue) => {
        apiService()
            .query(queryName, paramName+'='+paramValue)
                .then((response) => {
                    if (response.success) {
                        setItem(new mdlItem(response.data[0]))
                        // setItem(response.data[0])
                        let item = response.data[0];
                        //props.parentCallback(articleType ? articleType.name : '');  
                    } else {
                        console.log('Error:' + response.errorMessage);
                    }
                });  
    }

    const save = () => {
        if (itemId) {
           apiService().put('items', item)
                .then((response)=>{responseMessage(response, 'U ruajt me sukses!')}); 
        }
        else {
            addToast( 'Se pari ruani te dhanat bazike!', { appearance: 'info', autoDismiss: true, });
        }
    }

    const responseMessage = (response, message) => {
        if(response.success){
            addToast( message, { appearance: 'success', autoDismiss: true, });
        }
        else if(response.info){
            addToast( message, { appearance: 'info', autoDismiss: true, });
        }
        else{
            addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
        }
    }


    useEffect(() => {
        if( parseInt(itemId ) > 0){
            getItem('item', 'id', itemId)
        }
    }, [])

    useEffect(() => {
        props.save(() => save(item));
    }, [item])

    return (
        <div>
            <div className="card o-hidden border-0 shadow-lg">
                    <div className="card-body p-0">
                        <div className="row">
                                <div className="col-md-12 col-lg-12 col-xl-12 mb-2 flex px-2 px-md-0">
                                <div className="col-md-12 col-lg-6 px-md-3 px-0 pt-3 p-md-5">
                                    <div className='row'>
                                            <div className=" col-10 mx-auto mx-md-0 col-md-3    mb-3 px-1">
                                            <button onClick={() => setShowWeights(true)}  style={{height: "28.6px" , fontSize: "12px"}}  className="btn  btn-primary text-capitalize font-weight-bold align-top w-100">{helper().translate("WEIGHT")}</  button>
                                            </div>
                                            {showWeights &&
                                             <>
                                            <div className=" col-10 col-md-4  mx-auto col-lg-4  mb-3 px-1">
                                            <MDBInput name='weightBruto' onChange={(e) => setItem({...item, weightBruto: parseFloat(e.target.value) } )} type="number" className="form-control-sm  text-center px-0"  value={helper().toFixed2("weightBruto",item.weightBruto)}   label={helper().translate("WEIGHT_BRUTO")} />
                                            </div>
                                            <div className=" col-10 col-md-4 mx-auto  col-lg-4  mb-3 px-1">
                                            <MDBInput name='weightNeto' onChange={(e) => setItem({...item, weightNeto: parseFloat(e.target.value) } )} type="number" className="form-control-sm  text-center px-0" value={helper().toFixed2("weightNeto",item.weightNeto)}    label={helper().translate("WEIGHT_NETO")} />
                                            </div>
                                            </>}
                                            

                                    </div>
                                            {/* <div className=" col-12 col-md-4   mb-3 px-0">
                                                <Select
                                                    menuPortalTarget={ !props.props.fromPurchase ? document.body : ''} 
                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    onChange={(e) => {setItem({ ...item, accountA: e.value })}}
                                                    placeholder={accountPlaceholder?.first}
                                                    name="accountA"
                                                    options={firstAccountsGrup}
                                                    value = {accounts?.filter(account => account.value == item.accountA)}
                                                    //styles={customStyles}
                                                    className={errors.accountA != '' ? 'is-invalid-s': ''}
                                                />
                                                {errors.accountA != '' && <span className='error'>{errors.accountA}</span>}
                                            </div> */}
                                    
                                </div>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    )
}

export default ItemDetails